import { styled as i } from "./styled2.mjs";
import { KeyboardDoubleArrowLeftRounded as r } from "@mui/icons-material";
import { FLOATING_EXPAND_BUTTON_TOP as n, FLOATING_EXPAND_BUTTON_BOTTOM_MOBILE as e, INNER_EXPAND_BUTTON_RIGHT as a } from "./constants28.mjs";
import { Fab as p } from "./index98.mjs";
const b = i(p)`
	color: ${({ theme: o }) => o.palette.primary.contrast};
	padding: ${({ theme: o }) => o.spacing(0.626)};
	position: absolute;
	top: ${() => `${n}`};
	bottom: ${({ $isMobile: o }) => o ? `${e}px` : void 0};
	right: ${() => `${a}px`};
	z-index: ${({ theme: o }) => o.zIndex.drawer + 1};
	transition: ${({ theme: o, $isExpanded: t }) => o.transitions.create(["left", "right"], {
  easing: o.transitions.easing.sharp,
  duration: t ? o.transitions.duration.enteringScreen : o.transitions.duration.leavingScreen
})};
	transform: ${({ $canCollapse: o }) => o ? "rotate(180deg)" : void 0};
`;
i("div")`
	/* position: relative; */
	:before {
		content: '';
		position: absolute;
		top: 10px;
		left: -16px;
		height: 10px;
		width: 10px;
		border-bottom-left-radius: 50%;
		background: #000;
		box-shadow: 0 20px 0 0 #522d5b;
	}
`;
const g = i(r)`
	color: ${({ theme: o, $isMobile: t }) => o.palette.common.white};
`;
export {
  b as FloatingExpandIconButton,
  g as Icon
};
//# sourceMappingURL=styles119.mjs.map
